// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1HOwa","legacyBtn":"MutateMid_legacyBtn__2tzu4"};